import { closePopupHelper, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const openTariffBuyDialog = ({ onClose, ...data }) => openPopupHelper({ popupName: popupNames.TARIFF_BUY, data, onClose });

export const closeTariffBuyDialog = () => closePopupHelper(popupNames.TARIFF_BUY);
